import { QueryClient } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

// One client for the whole app, created at module scope. Creating it inside a
// component would hand every render a brand new (empty) cache, which makes every
// mounted query refetch on each render — an endless request loop.
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
      retry: (failureCount, error) => {
        // Cancelled requests (no Cognito session yet) and client errors such as
        // 401/403/404 will never succeed on a retry, so don't hammer the backend.
        if (axios.isCancel(error)) return false;
        const status = (error as AxiosError)?.response?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      }
    }
  }
});

export default queryClient;
